document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper('.swiper-container', {
        slidesPerView: "auto",
		spaceBetween: 45,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
			  	return '<span class="' + className + '">' + (index + 1) + "</span>";
			},
		},
    });
});